import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import AnimateHeight from "react-animate-height";
import { Minus, Plus } from "react-feather";
import { Links, LinkType } from "../../../main/blocks/Links/Links";
import { NavLink } from "../Navbar/Navbar";
import elements from "./Expander.module.scss";
export type ExpanderProps = {
  title: string;
  content: string;
  linksTitle: string;
  links: (NavLink | LinkType)[];
};
export const Expander: React.FC<ExpanderProps> = t0 => {
  const $ = _c(23);
  const {
    title,
    linksTitle,
    content,
    links
  } = t0;
  const [expanded, setExpanded] = useState(false);
  const t1 = `${elements.expanderWrapper} ${expanded ? elements.expanderWrapperOpen : undefined}`;
  let t2;
  if ($[0] !== expanded) {
    t2 = <button className="sr-only" onClick={e => {
      e.currentTarget.blur();
      setExpanded(!expanded);
    }} />;
    $[0] = expanded;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== title) {
    t3 = <p className="inngress">{title}</p>;
    $[2] = title;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== expanded) {
    t4 = expanded ? <Minus size={28} /> : <Plus size={28} />;
    $[4] = expanded;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t3 || $[8] !== t4) {
    t5 = <label className={elements.expanderHeader}>{t2}{t3}{t4}</label>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = expanded ? "auto" : 0;
  let t7;
  if ($[10] !== content) {
    t7 = <p>{content}</p>;
    $[10] = content;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== links || $[13] !== linksTitle) {
    t8 = links ? <><p className="inngress">{linksTitle}</p><Links links={links} /></> : null;
    $[12] = links;
    $[13] = linksTitle;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t6 || $[16] !== t7 || $[17] !== t8) {
    t9 = <div className={elements.expanderContent}><AnimateHeight height={t6} animateOpacity={true}>{t7}{t8}</AnimateHeight></div>;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t1 || $[20] !== t5 || $[21] !== t9) {
    t10 = <div className={t1}>{t5}{t9}</div>;
    $[19] = t1;
    $[20] = t5;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
};